var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 150,
    viewBox: "0 0 333 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.4 46.45L308.4 107.45L319.908 107.45C326.793 107.45 332.4 102.245 332.4 95.8526L332.4 58.0473C332.4 51.655 326.793 46.45 319.908 46.45L308.4 46.45ZM0.400024 23.8887L0.400019 130.011C0.400018 140.707 9.77554 149.45 21.2457 149.45L286.554 149.45C298.024 149.45 307.4 140.8 307.4 130.011L307.4 23.8887C307.4 13.1927 298.124 4.44995 286.554 4.44995L21.2457 4.44994C9.77554 4.44994 0.400024 13.0997 0.400024 23.8887Z",
    fill: "#BDCCD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308 100L308 42.3L319.7 42.3C326.7 42.3 332.4 48.0001 332.4 55.0001L332.4 87.3C332.4 94.3 326.7 100 319.7 100L308 100Z",
    fill: "#E4EAF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400019 121.144L0.400024 20.8559C0.400024 9.28038 9.80609 -1.3052e-05 21.3136 -1.25489e-05L287.486 -9.14161e-07C299.094 -4.0678e-07 308.4 9.38019 308.4 20.8559L308.4 121.144C308.4 132.72 298.994 142 287.486 142L21.3136 142C9.80609 142 0.400019 132.62 0.400019 121.144Z",
    fill: "#E4EAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.300013 121.4L0.300017 20.9C0.300018 9.3 9.70001 -2.82813e-06 21.2 -2.32545e-06L74.4 0L74.4 142.3L21.2 142.3C9.70001 142.3 0.300013 132.9 0.300013 121.4Z",
    fill: "#62778E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.55 102.55C193.55 102.55 192.15 95.75 183.05 88.05C173.95 80.35 168.05 78.95 165.75 77.95C163.35 76.95 151.35 72.55 143.55 58.95C143.55 58.95 150.25 76.15 156.65 82.25C162.65 87.95 167.95 91.7499 172.85 93.2499C178.85 95.2499 181.15 94.65 187.85 98.55C190.15 100.15 193.55 102.55 193.55 102.55Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.05 83.45C191.05 83.45 190.25 77.55 183.35 70.75C176.35 63.95 171.75 62.35 169.75 61.35C167.75 60.35 158.45 56.05 152.65 44.35C152.65 44.35 157.15 59.15 162.05 64.75C166.55 69.95 170.75 73.25 174.45 74.95C179.25 76.95 181.05 76.45 186.35 80.15C188.35 81.35 191.05 83.45 191.05 83.45Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M191.05 65.55C191.05 65.55 191.05 60.65 186.15 54.05C181.15 47.45 177.45 45.8499 175.95 44.6499C174.45 43.6499 167.15 38.95 163.75 28.45C163.75 28.45 165.75 41.35 169.25 46.45C172.45 51.25 175.45 54.5499 178.45 56.3499C182.25 58.5499 183.75 58.45 187.65 61.95C189.05 63.35 191.05 65.55 191.05 65.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg25);
export default __webpack_public_path__ + "static/media/25.8b844164dfa305f8fef8586f0cf8c7bb.svg";
export { ForwardRef as ReactComponent };